import styled from "@emotion/styled";
import { ParagraphHeaderSmall } from "../../typography/Paragraph";
import { PageLoading } from "../../Loading";
import ErrorMessage, { PageErrorContainer } from "../../Error";
import { User, AttorneyGetPayload } from "../../../../../api/src/types";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
import Avatar from "../../Avatar";
import { formatUserFullName, formatUserInitials } from "../../../utils/format";
import { Header } from "../utils/desktop/components";

const FullWidthHeader = styled(Header)`
  left: 0;
`;

const AttorneyHeader = ({
  user,
  attorney,
  isLoading,
  error,
}: {
  user?: User | undefined;
  attorney?: AttorneyGetPayload | undefined;
  isLoading?: boolean;
  error?: boolean | FetchBaseQueryError | SerializedError;
}) => {
  if (attorney?.stage !== "APPROVED") {
    return null;
  }

  if (isLoading) {
    return (
      <FullWidthHeader>
        <PageLoading />
      </FullWidthHeader>
    );
  }

  if (error) {
    return (
      <FullWidthHeader>
        <PageErrorContainer>
          <ErrorMessage> Error loading data </ErrorMessage>
        </PageErrorContainer>
      </FullWidthHeader>
    );
  }

  return (
    <FullWidthHeader>
      <Avatar initials={formatUserInitials(user)} />
      <ParagraphHeaderSmall>{formatUserFullName(user)}</ParagraphHeaderSmall>
    </FullWidthHeader>
  );
};

export default AttorneyHeader;
